import type { JSX } from 'react';

import { Loader } from '@change-corgi/design-system-legacy/components/progressiveDisclosure';

import { withPrefetchedData } from 'src/shared/prefetch';

import {
	LocationSitemapPageContextProvider,
	type LocationSitemapPagePrefetchedDataProps,
	prefetchPageContext,
} from 'src/app/pages/locationSitemap/pageContext';

import { Layout } from '../layout';

import { LocationSitemapErrorHandler } from './ErrorHandler';

export const LocationSitemap = withPrefetchedData(
	function LocationSitemap({ prefetchedData }: LocationSitemapPagePrefetchedDataProps): JSX.Element {
		return (
			<LocationSitemapPageContextProvider
				prefetchedData={prefetchedData}
				errorHandler={LocationSitemapErrorHandler}
				loadingFallback={<Loader size="m" my={256} mx="auto" />}
			>
				<Layout />
			</LocationSitemapPageContextProvider>
		);
	},
	{
		prefetchName: __MODULE_HASH__,

		prefetchData: async (context) => prefetchPageContext(context),
	},
);
